import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import api from "../Api";
import Popup from "../components/PopUP";
import { useParams, useNavigate } from "react-router-dom";
import MarkdownText from "../components/MarkdownText";

export default function ReportQuestion() {
  const { game, setId, questionId } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");

  const gamesList = [
    { id: 1, name: "Calculation", path: "calculation" },
    { id: 2, name: "One Word", path: "one-word" },
    { id: 3, name: "Quiz", path: "quiz" },
    { id: 4, name: "Blackbox", path: "blackbox" },
  ];

  const getGameEndpoint = (gamePath) => {
    const gameMap = {
      calculation: "calculation",
      "one-word": "one_word",
      quiz: "quiz",
      blackbox: "blackbox",
    };
    return gameMap[gamePath] || gamePath;
  };

  const fetchReportDetails = useCallback(async () => {
    setLoading(true);
    try {
      const gameEndpoint = getGameEndpoint(game);
      const response = await api.get(
        `${gameEndpoint}/admin/report-question/${questionId}`
      );

      setReport(response.data.data);
      setPopupMessage("Report loaded successfully");
    } catch (error) {
      console.error("API Error:", error);
      setPopupMessage("Failed to load report details");
    } finally {
      setLoading(false);
    }
  }, [game, questionId]);

  useEffect(() => {
    fetchReportDetails();
  }, [fetchReportDetails]);

  const handleApprove = async () => {
    try {
      const gameEndpoint = getGameEndpoint(game);
      await api.post(`${gameEndpoint}/admin/report-question/${questionId}/approve`);
      setPopupMessage("Report approved successfully");
      setTimeout(() => navigate(-1), 1500);
    } catch (error) {
      console.error("Error approving report:", error);
      setPopupMessage("Failed to approve report");
    }
  };

  const handleReject = async () => {
    try {
      const gameEndpoint = getGameEndpoint(game);
      await api.post(`${gameEndpoint}/admin/report-question/${questionId}/reject`);
      setPopupMessage("Report rejected successfully");
      setTimeout(() => navigate(-1), 1500);
    } catch (error) {
      console.error("Error rejecting report:", error);
      setPopupMessage("Failed to reject report");
    }
  };

  const gameName = gamesList.find(g => g.path === game)?.name || game;

  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>Report Details - {gameName}</h1>
                      </div>
                    </div>
                  </div>

                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "400px",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <img
                          src="/assets/images/loader.gif"
                          alt="Loading..."
                          style={{
                            maxWidth: "100px",
                            marginBottom: "20px",
                          }}
                        />
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#666",
                            fontWeight: "500",
                          }}
                        >
                          Loading report details...
                        </p>
                      </div>
                    </div>
                  ) : report ? (
                    <div className="common-table-wrapper mt-4">
                      {/* User Information */}
                      <div className="mt-4 mb-4">
                        <div className="common_sub_heading_wrapper mb-3">
                          <h2>User Information</h2>
                        </div>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <div className="info-block">
                              <label className="fw-bold">Name:</label>
                              <p>
                                {report.first_name} {report.last_name}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="info-block">
                              <label className="fw-bold">Email:</label>
                              <p>{report.email}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Report Reason */}
                      <div className="mt-4 mb-4">
                        <div className="common_sub_heading_wrapper mb-3">
                          <h2>Report Reason</h2>
                        </div>
                        <div className="alert alert-warning" role="alert">
                          <p className="mb-0">{report.reason}</p>
                        </div>
                      </div>

                      {/* Question Details */}
                      {report.payload && (
                        <div className="mt-4 mb-4">
                          <div className="common_sub_heading_wrapper mb-3">
                            <h2>Question Details</h2>
                          </div>

                          {/* Question Title */}
                          <div className="mb-3">
                            <label className="fw-bold">Title:</label>
                            <p>{report.payload.title}</p>
                          </div>

                          {/* Question Text */}
                          <div className="mb-3">
                            <label className="fw-bold">Question:</label>
                            <p>{report.payload.question}</p>
                          </div>

                          {/* Options */}
                          <div className="mb-4">
                            <label className="fw-bold mb-3 d-block">
                              Options:
                            </label>
                            <div className="row g-2">
                              {report.payload.options &&
                                report.payload.options.map((option, index) => (
                                  <div className="col-md-6" key={index}>
                                    <div
                                      className="p-3 border rounded"
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                        borderLeft:
                                          option.label ===
                                          report.payload.answer.split(",")[0]
                                            ? "4px solid #28a745"
                                            : "4px solid #dee2e6",
                                      }}
                                    >
                                      <strong>{option.label}:</strong>{" "}
                                      {option.value}
                                      {option.label ===
                                        report.payload.answer.split(",")[0] && (
                                        <span className="badge bg-success ms-2">
                                          Correct Answer
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>

                          {/* Answer */}
                          <div className="mb-3">
                            <label className="fw-bold">Correct Answer:</label>
                            <p className="text-success fw-bold">
                              {report.payload.answer}
                            </p>
                          </div>

                          {/* Explanation */}
                          <div className="mb-3">
                            <label className="fw-bold">Explanation:</label>
                            <div
                              className="p-3 border rounded"
                              style={{ backgroundColor: "#f8f9fa" }}
                            >
                              <MarkdownText>{report.payload.explanation}</MarkdownText>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div className="mt-4 mb-4">
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-success"
                            onClick={handleApprove}
                          >
                            Approve Report
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={handleReject}
                          >
                            Reject Report
                          </button>
                          <button
                            className="btn btn-secondary"
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert">
                      <p>Failed to load report details</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
